export default "__VITE_ASSET__BoMurd2b__"